import { IBillingAddress } from "../../services/online-application.types";

export enum FieldNames {
  AccountStreet1 = "street1",
  AccountStreet2 = "street2",
  AccountCity = "city",
  AccountPostalCode = "postal_code",
  AccountCountry = "country",
  AccountRegion = "state_province",
}

export const COUNTRIES_WITH_STATE_PROVINCE = ["CA", "US"];

export const billingAddressInitialValues: IBillingAddress = {
  street1: "",
  street2: "",
  city: "",
  postal_code: "",
  country: "",
  state_province: "",
};
